import { Factory } from 'miragejs'

export default Factory.extend({
  licenceCount: 300,
  remainingLicences: 200,
  studentCount: 100,
  subscriptionType: 'reading',
})
